import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type { FilterParams, SlugParamKey } from '@core/Entities/Search/QueryParams.entity';
import { MULTISELECT_FILTERS_KEY } from '@core/Services/Search/Filters.constants';

import { getFilterValueFromSlugItem } from './GetFilterValueFromSlugItem';

export const getFilterFromSlugItem = (
  slugValue: string,
  filterKey: SlugParamKey,
  root: PlpRoot,
): FilterParams => {
  const value = getFilterValueFromSlugItem(slugValue, filterKey);

  if (!value) return {};

  if (filterKey === 'price') {
    return root === 'lease-deals'
      ? { 'monthly-price__lte': value as string }
      : { price__lte: value as string };
  }

  // if (filterKey === 'monthly-price') {
  //   return { 'monthly-price__lte': value as string };
  // }

  if (filterKey === 'badge_engine_cc') {
    return { 'engine-size__gte': value as string, 'engine-size__lte': value as string };
  }

  const formattedValue = MULTISELECT_FILTERS_KEY.includes(filterKey) ? [value] : value;

  return { [filterKey as keyof FilterParams]: formattedValue };
};
